<template>
  <v-app>
    <SideBarAdmin />
    <!-- <SideHeader /> -->
    <div>
      <v-tabs color="#1b5e20">
        <v-tab>Table</v-tab>
        <v-tab-item>
          <v-card>
            <v-card-text class="grey lighten-4">
              <v-sheet max-width="100%" height="100%" class="mx-auto"></v-sheet>
              <v-subheader> Courier </v-subheader>
              <v-card-title>
                <v-dialog v-model="dialog" max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="text-h5">{{ formTitle }}</span>
                    </v-card-title>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="12" sm="6" md="12">
                              <v-chip :color="getColor(editedItem.is_suspend)" dark>
                                <v-text v-if="editedItem.is_suspend == 'y'"
                                  >Active</v-text
                                >
                                <v-text v-else>Non Active</v-text>
                              </v-chip>
                            </v-col>
                            <v-col cols="12" sm="6" md="12">
                              <v-text-field v-model="editedItem.text" label="Courier">
                              </v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                    </v-form>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="#1b5e20"
                        class="white--text"
                        elevation="2"
                        @click="close"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        color="#1b5e20"
                        class="white--text"
                        elevation="2"
                        @click="save"
                      >
                        <v-chip :color="getColorBtn(editedItem.is_suspend)" dark>
                          <v-text v-if="editedItem.is_suspend == 'y'">Non Active</v-text>
                          <v-text v-else>Active</v-text>
                        </v-chip>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-spacer></v-spacer>
                <v-text-field
                  v-model="keyword"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  @input="doSearch"
                >
                </v-text-field>
              </v-card-title>
              <v-data-table
                ref="vDataTable"
                :headers="headers"
                :items="couriers"
                hide-default-footer
                class="elevation-0"
              >
                <template #item="{ item, index, headers }">
                  <tr>
                    <td>
                      {{ index + 1 + (page - 1) * 10 }}
                    </td>
                    <td>
                      <v-chip :color="getColor(item.is_suspend)" dark>
                        <v-text v-if="item.is_suspend == 'y'">Active</v-text>
                        <v-text v-else>Non Active</v-text>
                      </v-chip>
                    </td>
                    <td>
                      {{ item.text }}
                    </td>

                    <td>
                      <v-icon small class="mr-2" @click="editItem(item)">
                        mdi-pencil
                      </v-icon>
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <div class="text-center">
                <v-pagination
                  v-model="page"
                  @input="go"
                  :length="lengthPage"
                  :total-visible="5"
                  color="#1b5e20"
                >
                </v-pagination>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </div>
    <div class="text-center">
      <v-dialog v-model="progressBar" width="100" hide-overlay>
        <v-progress-circular
          :size="60"
          color="primary"
          indeterminate
          align-center
          justify-center
        >
        </v-progress-circular>
      </v-dialog>
    </div>
  </v-app>
</template>
<script>
import SideBarAdmin from "../components/SideBarAdmin.vue";
// import SideHeader from '../components/SideHeader.vue'
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    SideBarAdmin,
    // SideHeader,
  },

  data: () => ({
    valid: true,
    couriers: [],
    keyword: "",
    page: 0,
    lengthPage: 0,
    headers: [
      { text: "No", value: "id" },
      { text: "Status", value: "is_suspend" },
      { text: "Courier", value: "text" },
      { text: "Actions", sortable: false },
    ],
    dialog: false,
    editedIndex: -1,
    editedItem: {
      text: "",
      is_suspend: "",
    },
    defaultItem: {
      text: "",
      is_suspend: "",
    },
    progressBar: false,
    nameRules: [
      (v) => !!v || "Courier Name is required",
      (v) => (v && v.length <= 100) || "Max 100 characters",
    ],
  }),
  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
    formTitle() {
      return this.editedIndex === -1 ? "New Courier" : "Edit Courier";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  created() {
    this.go();
  },
  methods: {
    ...mapActions({
      setAlert: "alert/set",
      setAuth: "auth/set",
    }),
    go() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      let url = "/courier?page=" + this.page;
      this.axios
        .get(url, config)
        .then((response) => {
          let { data } = response.data;
          let { meta } = response.data;
          this.couriers = data;
          // jumlah halaman di dapat dari meta endpoint couriers
          this.lengthPage = meta.last_page;
          this.page = meta.current_page;
        })
        .catch((error) => {
          let { responses } = error;
          console.log(responses);
        });
    },
    getColor(is_suspend) {
      if (is_suspend == "y") return "green";
      else return "red";
    },
    getColorBtn(is_suspend) {
      if (is_suspend == "y") return "red";
      else return "green";
    },
    doSearch() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      let keyword = this.keyword;
      if (keyword.length > 0) {
        this.axios
          .get("/courier/search/" + keyword, config)
          .then((response) => {
            let { data } = response.data;
            this.couriers = data;
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.go();
      }
    },
    editItem(item) {
      this.editedIndex = this.couriers.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.$refs.form.validate()) {
        this.progressBar = true;
        let formData = new FormData();
        formData.set("user_id", this.user.id);
        formData.set("id", this.editedItem.id);
        formData.set("text", this.editedItem.text);
        formData.set("is_suspend", this.editedItem.is_suspend);
        let config = {
          headers: {
            Authorization: "Bearer " + this.user.api_token,
          },
        };
        if (this.editedIndex > -1) {
          Object.assign(this.couriers[this.editedIndex], this.editedItem);
          this.axios
            .post("/courier/update", formData, config)
            .then((response) => {
              let { data } = response;
              this.setAuth(data.data);
              this.setAlert({
                status: true,
                text: data.message,
                color: data.status,
              });
              this.couriers.push(this.editedItem);
              this.clear();
            })
            .catch((error) => {
              let { data } = error;
              this.setAlert({
                status: true,
                text: data.message,
                color: "error",
              });
              this.clear();
            });
        }
      }
    },
    clear() {
      this.go();
      this.close();
      this.progressBar = false;
    },
  },
};
</script>
<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.position-relative {
  position: relative;
}
</style>
